module.exports = __webpack_public_path__ + "2b3cf1b0150a8e2ddeb4cfdfb7140a36.png";